<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/v8E7gt/tc-custom/9780292753969.jpg?1728259535089" alt="This image is the cover for the book Galveston and the 1900 Storm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Galveston and the 1900 Storm
      </h1>
      <p class="bookDescription body article font2">
        <b>Spur Award Nominee: How Galveston, Texas, reinvented itself after historic disaster: “A riveting narrative . . . Absorbing [and] well-illustrated.” —<i>Library Journal</i></b><br/><br/>The Galveston storm of 1900 reduced a cosmopolitan and economically vibrant city to a wreckage-strewn wasteland where survivors struggled without shelter, power, potable water, or even the means to summon help. At least 6,000 of the city's 38,000 residents died in the hurricane. Many observers predicted that Galveston would never recover and urged that the island be abandoned. Instead, the citizens of Galveston seized the opportunity, not just to rebuild, but to reinvent the city in a thoughtful, intentional way that reformed its government, gave women a larger role in its public life, and made it less vulnerable to future storms and flooding.<br/><br/>This extensively illustrated history tells the full story of the 1900 Storm and its long-term effects. The authors draw on survivors’ accounts to vividly recreate the storm and its aftermath. They describe the work of local relief agencies, aided by Clara Barton and the American Red Cross, and show how their short-term efforts grew into lasting reforms. At the same time, the authors reveal that not all Galvestonians benefited from the city’s rebirth, as African Americans found themselves increasingly shut out from civic participation by Jim Crow segregation laws. As the centennial of the 1900 Storm prompts remembrance and reassessment, this complete account will be essential and fascinating reading for all who seek to understand Galveston’s destruction and rebirth.<br/><br/><i>Runner-up, Spur Award for Best Western Nonfiction—Contemporary, Western Writers Of America</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Bellis Bixel, Elizabeth Hayes Turner
      </h2>
      
      <p class="authorDescription body article">Patricia Bellis Bixel is a professional historian and assistant editor of the Journal of Southern History at Rice University.Elizabeth Hayes Turner is Professor of History at the University of North Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press, Austin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d945b17